
import usefulLinkActions from '../../../actions/usefulLinkActions';
import usefulLinkInputFields from './usefulLinkInputFields';
import generateEntityCreator from '../../../hocs/generateEntityCreator';

const UsefulLinkCreator = generateEntityCreator({
  formName: 'usefulLinkCreationForm',
  entityActions: usefulLinkActions,
  returnRoutePath: '/useful-links-listing',
  fields: usefulLinkInputFields,
});

export default UsefulLinkCreator;
